import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import '../../globals/scss/style.scss'
import './styles/ace.scss'
import { getReCaptchaSitekey } from '../../utils/config'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Provider } from 'react-redux'
import { store } from './store/store'

const siteKey = getReCaptchaSitekey(window.location.hostname)

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleReCaptchaProvider>,
  document.getElementById('main') || document.createElement('div'),
)
